export default __webpack_public_path__ + "static/media/amertrad2.fabc1905.png";